import React from "react";
import SendPlug from "../send_plug/SendPlug";
import { ENUM_CHAT_TAB } from "../../../../common/enums";
import useTips from "../../../../../hooks/useTips";
import useNickname from "../../../../../hooks/site/useNickname";
import { useAppSelector } from "../../../../../store/index.ts";

export default function SendPlugContainer({
  tab,
  onChangeAmount,
  amount,
  setCurrentToken,
  skipPlug,
  tabFree,
}) {
  const tabLovense = tab === ENUM_CHAT_TAB.lovense;
  const { postSimpleTips, postLovenseTips } = useTips();
  const { name } = useNickname();
  const levels = useAppSelector((state) => state.chat.lovense.tips.levels);

  const getLevelByMinMax = () => {
    console.log("levels", levels);

    for (let level in levels) {
      const info = levels[level];
      const max = info.max === "infinity" ? Infinity : info.max;

      if (info.min < amount && max >= amount) {
        return level;
      }
    }
  };

  const postLovense = () => {
    const level = getLevelByMinMax();
    const lovense = { id: level, nickname: name };
    const info = { amount, lovense };

    postLovenseTips(info);
  };

  return (
    <SendPlug
      onChangeAmount={onChangeAmount}
      amount={amount}
      setCurrentToken={setCurrentToken}
      skipPlug={skipPlug}
      className={!tabFree ? "lovense" : ""}
      isSend={!tabFree}
      postTips={tabLovense ? postLovense : postSimpleTips}
    />
  );
}
